import type { JSX } from 'react';
import { Translation } from 'react-i18next';

export const CONFIRMATION_PERIOD: {
  1: JSX.Element;
  2: JSX.Element;
  3: JSX.Element;
  4: JSX.Element;
} = {
  1: <Translation>{(t) => <>{t('form.option.six-months')}</>}</Translation>,
  2: <Translation>{(t) => <>{t('form.option.twelve-months')}</>}</Translation>,
  3: <Translation>{(t) => <>{t('form.option.thirty-six-months')}</>}</Translation>,
  4: <Translation>{(t) => <>{t('form.option.eighteen-months')}</>}</Translation>,
};